(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fl-announcement-bar')) {
    customElements.define(
      'fl-announcement-bar',
      class extends HTMLElement {
        connectedCallback() {
          this.messages = Array.from(this.querySelectorAll('[data-announcement]'));
          this.rotator = this.querySelector('[data-rotator]');
          if (this.messages.length < 2) return;

          this.classList.add('is-enhanced');
          this.toggle = this.querySelector('[data-toggle]');
          this.userPaused = false;
          this.index = 0;
          this.timer = null;
          this.delay = 5000;
          const seconds = parseInt(this.dataset.interval, 10);
          if (seconds > 0) this.delay = seconds * 1000;
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

          this.onMotionChange = () => {
            if (this.reducedMotion.matches) {
              this.pause();
            } else {
              this.play();
            }
            this.syncToggle();
          };
          this.reducedMotion.addEventListener('change', this.onMotionChange);

          const prev = this.querySelector('[data-prev]');
          const next = this.querySelector('[data-next]');
          if (prev) prev.addEventListener('click', () => this.step(-1));
          if (next) next.addEventListener('click', () => this.step(1));

          if (this.toggle) {
            this.toggle.addEventListener('click', () => {
              this.userPaused = !this.userPaused;
              if (this.userPaused) {
                this.pause();
              } else {
                this.play();
              }
              this.syncToggle();
            });
          }

          this.addEventListener('mouseenter', () => this.pause());
          this.addEventListener('mouseleave', () => {
            if (!this.contains(document.activeElement)) this.play();
          });
          this.addEventListener('focusin', () => this.pause());
          this.addEventListener('focusout', (event) => {
            if (!this.contains(event.relatedTarget)) this.play();
          });

          if (window.Shopify && window.Shopify.designMode) {
            this.onBlockSelect = (event) => {
              const i = this.messages.indexOf(event.target);
              if (i > -1) {
                this.pause();
                this.show(i);
              }
            };
            this.onBlockDeselect = (event) => {
              if (this.messages.indexOf(event.target) > -1) this.play();
            };
            document.addEventListener('shopify:block:select', this.onBlockSelect);
            document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
          }

          this.play();
          this.syncToggle();
        }

        disconnectedCallback() {
          if (this.timer) clearInterval(this.timer);
          if (this.reducedMotion && this.onMotionChange) {
            this.reducedMotion.removeEventListener('change', this.onMotionChange);
          }
          if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
          if (this.onBlockDeselect) document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
        }

        show(i) {
          const count = this.messages.length;
          this.index = ((i % count) + count) % count;
          this.messages.forEach((msg, j) => msg.classList.toggle('is-active', j === this.index));
        }

        step(delta) {
          if (this.rotator) this.rotator.setAttribute('aria-live', 'polite');
          this.show(this.index + delta);
        }

        play() {
          if (this.userPaused) return;
          if (this.reducedMotion.matches) return;
          if (this.timer) clearInterval(this.timer);
          if (this.rotator) this.rotator.setAttribute('aria-live', 'off');
          this.timer = setInterval(() => this.show(this.index + 1), this.delay);
        }

        pause() {
          if (this.timer) clearInterval(this.timer);
          this.timer = null;
          if (this.rotator) this.rotator.setAttribute('aria-live', 'polite');
        }

        syncToggle() {
          if (!this.toggle) return;
          const isPaused = this.userPaused || this.reducedMotion.matches;
          this.toggle.classList.toggle('is-paused', isPaused);
          const label = isPaused ? this.toggle.dataset.labelPlay : this.toggle.dataset.labelPause;
          if (label) this.toggle.setAttribute('aria-label', label);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class FlCartDrawer extends HTMLElement {
    connectedCallback() {
      this.sectionId = 'cart-drawer';
      this.panel = this.querySelector('[data-cart-panel]');
      this.statusEl = this.querySelector('[data-cart-status]');
      this.openerEl = null;
      this.isBusy = false;

      this.onDocClick = this.handleDocClick.bind(this);
      this.onDocSubmit = this.handleDocSubmit.bind(this);
      this.onKeydown = this.handleKeydown.bind(this);
      this.onFieldChange = this.handleFieldChange.bind(this);
      this.onFocusIn = this.handleFocusIn.bind(this);

      document.addEventListener('click', this.onDocClick);
      document.addEventListener('submit', this.onDocSubmit);
      // Last line of defence for the focus trap: whatever moves focus out of an
      // open drawer — a Tab the page swallowed, a script, the cookie-consent
      // banner Shopify injects at the top of <body> — it comes straight back.
      document.addEventListener('focusin', this.onFocusIn, true);
      // Escape / Tab are bound on the document, not on the element: after a
      // re-render the browser can park focus on <body>, and a listener scoped
      // to the drawer would then never see the key.
      // Capture phase: a third-party widget (consent banner, app embed) that
      // stops propagation on keydown must not be able to disarm the trap.
      document.addEventListener('keydown', this.onKeydown, true);
      this.addEventListener('change', this.onFieldChange);

      if (window.Shopify && window.Shopify.designMode) {
        this.onSectionSelect = (event) => {
          if (event.target.contains(this)) this.open();
        };
        this.onSectionDeselect = (event) => {
          if (event.target.contains(this)) this.close();
        };
        document.addEventListener('shopify:section:select', this.onSectionSelect);
        document.addEventListener('shopify:section:deselect', this.onSectionDeselect);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
      document.removeEventListener('submit', this.onDocSubmit);
      document.removeEventListener('keydown', this.onKeydown, true);
      document.removeEventListener('focusin', this.onFocusIn, true);
      if (this.onSectionSelect) {
        document.removeEventListener('shopify:section:select', this.onSectionSelect);
        document.removeEventListener('shopify:section:deselect', this.onSectionDeselect);
      }
      document.documentElement.removeAttribute('data-fl-cart-lock');
      if (this.focusTimer) window.clearTimeout(this.focusTimer);
      if (this.statusTimer) window.clearTimeout(this.statusTimer);
    }

    handleDocClick(event) {
      const opener = event.target.closest('[data-cart-open]');
      if (opener) {
        event.preventDefault();
        this.open(opener);
        return;
      }
      if (!this.contains(event.target)) return;
      if (event.target.closest('[data-cart-close]')) {
        this.close();
        return;
      }
      const control = event.target.closest('[data-cart-minus], [data-cart-plus], [data-cart-remove]');
      if (!control) return;
      event.preventDefault();
      const key = control.getAttribute('data-key');
      if (!key) return;
      const current = parseInt(control.getAttribute('data-qty'), 10) || 0;
      let quantity = 0;
      if (control.hasAttribute('data-cart-minus')) quantity = Math.max(0, current - 1);
      if (control.hasAttribute('data-cart-plus')) quantity = current + 1;
      this.changeLine(key, quantity);
    }

    handleDocSubmit(event) {
      const form = event.target.closest('[data-quick-add], [data-product-form]');
      if (!form) return;
      // While a previous add is still in flight, let the browser submit natively
      // instead of swallowing the event: preventing it and then bailing on the
      // isBusy guard lost the second add entirely on a fast double click.
      if (this.isBusy) return;
      event.preventDefault();
      this.addToCart(form, event.submitter);
    }

    handleFieldChange(event) {
      const qty = event.target.closest('[data-cart-qty]');
      if (qty) {
        const value = Math.max(0, parseInt(qty.value, 10) || 0);
        this.changeLine(qty.getAttribute('data-key'), value);
        return;
      }
      const note = event.target.closest('[data-cart-note]');
      if (note) this.saveNote(note.value);
    }

    handleKeydown(event) {
      if (!this.classList.contains('is-open') || !this.panel) return;
      if (event.key === 'Escape' || event.key === 'Esc') {
        event.preventDefault();
        event.stopPropagation();
        this.close();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = this.getFocusable();
      if (focusable.length === 0) {
        event.preventDefault();
        this.panel.focus();
        return;
      }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      const active = document.activeElement;
      // Anything that is not one of the panel's own focusable controls — the
      // bare panel (tabindex="-1"), the scrim, <body> after a re-render, or an
      // element the page moved focus to — is treated as "outside": the next Tab
      // is redirected to an end of the ring instead of walking the document.
      const index = focusable.indexOf(active);
      if (index === -1) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
        return;
      }
      if (event.shiftKey) {
        if (index === 0) {
          event.preventDefault();
          last.focus();
        }
        return;
      }
      if (index === focusable.length - 1) {
        event.preventDefault();
        first.focus();
      }
    }

    handleFocusIn(event) {
      if (!this.classList.contains('is-open')) return;
      if (this.isRestoringFocus) return;
      if (!this.panel) return;
      const target = event.target;
      if (target === this.panel || this.panel.contains(target)) return;
      this.isRestoringFocus = true;
      const focusable = this.getFocusable();
      const fallback = focusable[0] || this.panel;
      if (fallback) fallback.focus();
      this.isRestoringFocus = false;
    }

    getFocusable() {
      const selector =
        'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';
      const nodes = Array.prototype.slice.call(this.panel.querySelectorAll(selector));
      const candidates = nodes.filter((el) => {
        if (el.hasAttribute('aria-hidden') || el.closest('[aria-hidden="true"], [hidden]')) return false;
        return true;
      });
      const visible = candidates.filter((el) => {
        return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
      });
      // While the panel is still sliding in, offset sizes can read 0 for every
      // control. Falling back to the unmeasured list keeps the trap armed on
      // the very first Tab instead of collapsing to "no focusable element".
      return visible.length > 0 ? visible : candidates;
    }

    focusPanel() {
      // Move focus to the first control the shopper can actually act on —
      // never the scrim, never the bare panel — on EVERY opening path (click,
      // Enter on the cart link, automatic open after an add to cart).
      // The panel is visibility:hidden until the open class has been painted,
      // and a freshly re-rendered panel can take a frame more, so the attempt
      // is repeated across frames AND timers until focus really landed inside.
      if (this.focusTimer) {
        window.clearTimeout(this.focusTimer);
        this.focusTimer = null;
      }
      const delays = [0, 0, 16, 50, 120, 250, 400];
      let step = 0;
      // Focus resting on the bare panel does NOT count as done: that is exactly
      // the state where the first Tab used to walk out of the drawer.
      const landed = () => {
        const active = document.activeElement;
        return !!active && active !== this.panel && this.panel.contains(active);
      };
      const attempt = () => {
        this.focusTimer = null;
        if (!this.classList.contains('is-open') || !this.panel) return;
        if (landed()) return;
        const focusable = this.getFocusable();
        const target = focusable[0] || this.panel;
        try {
          target.focus({ preventScroll: true });
        } catch (error) {
          target.focus();
        }
        if (landed() || target === this.panel) return;
        if (step < delays.length) {
          const delay = delays[step];
          step += 1;
          if (delay === 0) {
            window.requestAnimationFrame(attempt);
          } else {
            this.focusTimer = window.setTimeout(attempt, delay);
          }
        }
      };
      attempt();
    }

    open(trigger) {
      // Re-entrant on purpose: an add to cart re-renders the panel while it is
      // already open, and focus must be (re)placed inside it on every path —
      // click, keyboard, cart link, automatic open after an add.
      if (trigger) this.openerEl = trigger;
      const wasOpen = this.classList.contains('is-open');
      // Already open with focus on one of its controls (quantity change, note
      // field): leave the caret where the shopper put it. Focus resting on the
      // bare panel is NOT "inside" for this purpose — it has to be moved on to
      // a real control, otherwise the first Tab walks out of the drawer.
      const active = document.activeElement;
      const focusHeld =
        wasOpen && this.panel && active && active !== this.panel && this.panel.contains(active);
      if (focusHeld) return;
      if (!wasOpen) {
        if (!this.openerEl) this.openerEl = document.activeElement;
        this.classList.add('is-open');
        document.documentElement.setAttribute('data-fl-cart-lock', '');
      }
      this.focusPanel();
    }

    close() {
      if (!this.classList.contains('is-open')) return;
      if (this.focusTimer) {
        window.clearTimeout(this.focusTimer);
        this.focusTimer = null;
      }
      this.classList.remove('is-open');
      document.documentElement.removeAttribute('data-fl-cart-lock');
      if (this.openerEl && document.contains(this.openerEl) && typeof this.openerEl.focus === 'function') {
        this.openerEl.focus();
      }
      this.openerEl = null;
    }

    findLabelTextNode(button) {
      // First non-blank text node of a button: the visible wording of the
      // quick-add buttons. Text.textContent reads and writes like an element's.
      for (const node of button.childNodes) {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '') return node;
      }
      return null;
    }

    setLoading(button) {
      if (!button) return function () {};
      // Only the label's text is swapped. Overwriting the button's innerHTML
      // detached the [data-add-label] node that <fl-product> holds a reference
      // to, so the product button stayed stuck on "Adding…" after the first add.
      // Quick-add buttons have no [data-add-label]: their visible wording is a
      // bare text node beside a visually-hidden product name, and writing
      // textContent on the whole button flattened that span into visible text
      // on restore. Swapping only the text node leaves the span untouched.
      const label = button.querySelector('[data-add-label]') || this.findLabelTextNode(button) || button;
      const addingText = this.dataset.addingText;
      const addedText = this.dataset.addedText;
      // A confirmation from a previous add may still be on screen: cancel its
      // pending revert and reuse the wording it captured, otherwise "Added to
      // cart" would be recorded as this button's original label.
      window.clearTimeout(button.flRevertTimer);
      let original = label.textContent;
      if (typeof button.flOriginalLabel === 'string') original = button.flOriginalLabel;
      // <fl-product>'s form-level submit listener runs before this document-
      // level one and has already relabelled the button "Adding…": recover the
      // real wording from the host element instead of recording the loading
      // text, which kept a FAILED add reading "Adding…" until <fl-product>'s
      // 8 s fallback timer finally reset it.
      if (original === addingText) {
        const host = button.closest('[data-text-add]');
        if (host && host.dataset.textAdd) original = host.dataset.textAdd;
      }
      button.flOriginalLabel = original;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      label.textContent = addingText;
      // The button is freed as soon as the request settles, but the label only
      // goes back to its original wording after the confirmation has had time
      // on screen: restoring it in the same tick as the add succeeded painted
      // over "Added to cart" before it was ever visible.
      return function (added) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (!added) {
          if (label.textContent === addingText) label.textContent = original;
          button.flOriginalLabel = null;
          return;
        }
        label.textContent = addedText;
        button.flRevertTimer = window.setTimeout(function () {
          // <fl-product> relabels the same button on fl:cart:change and on
          // variant changes, so only take back a label that is still ours.
          if (label.textContent === addedText) label.textContent = original;
          button.flOriginalLabel = null;
        }, 2000);
      };
    }

    async addToCart(form, submitter) {
      if (this.isBusy) return;
      this.isBusy = true;
      const button = submitter || form.querySelector('[type="submit"]');
      const restore = this.setLoading(button);
      const body = new FormData(form);
      // Quick-add forms carry the variant id on the submit button itself
      // (name="id"), and FormData(form) never includes the submitter. Rely on
      // the resolved fallback so script-triggered submits and browsers without
      // SubmitEvent.submitter still post the id.
      if (button && button.name) body.append(button.name, button.value);
      let added = false;
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: body
        });
        if (!response.ok) {
          let message = this.dataset.errorText;
          try {
            const data = await response.json();
            if (data && data.description) message = data.description;
          } catch (error) {
            // keep the generic fallback message
          }
          this.showError(message);
          this.open(button);
          return;
        }
        this.clearError();
        await this.refresh();
        added = true;
        this.open(button);
        // Announced AFTER refresh(): renderContents() replaces the drawer's
        // contents and can move focus, and an announcement written before that
        // was swallowed. The wording comes from products.product.added_to_cart
        // through data-added-text, so it follows the storefront locale.
        this.announce(this.dataset.addedText, false);
      } catch (error) {
        this.showError(this.dataset.errorText);
        this.open(button);
      } finally {
        restore(added);
        this.isBusy = false;
      }
    }

    async changeLine(key, quantity) {
      if (this.isBusy || !key) return;
      this.isBusy = true;
      this.classList.add('is-busy');
      try {
        const response = await fetch(this.dataset.changeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity })
        });
        if (response.ok) {
          this.clearError();
        } else {
          let message = this.dataset.errorText;
          try {
            const data = await response.json();
            if (data && data.description) message = data.description;
          } catch (error) {
            // keep the generic fallback message
          }
          this.showError(message);
        }
        await this.refresh();
      } catch (error) {
        this.showError(this.dataset.errorText);
      } finally {
        this.classList.remove('is-busy');
        this.isBusy = false;
      }
    }

    async saveNote(note) {
      try {
        await fetch(this.dataset.updateUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: note })
        });
      } catch (error) {
        // note saving is best effort
      }
    }

    async refresh() {
      const sectionUrl = this.dataset.rootUrl + '?sections=' + this.sectionId;
      const cartUrl = this.dataset.cartUrl + '.js';
      const results = await Promise.all([
        fetch(sectionUrl).then((response) => response.json()),
        fetch(cartUrl, { headers: { Accept: 'application/json' } }).then((response) => response.json())
      ]);
      const sections = results[0];
      const cart = results[1];
      if (sections && sections[this.sectionId]) this.renderContents(sections[this.sectionId]);
      let itemCount = 0;
      if (cart && typeof cart.item_count === 'number') itemCount = cart.item_count;
      document.dispatchEvent(
        new CustomEvent('fl:cart:change', { bubbles: true, detail: { itemCount: itemCount } })
      );
    }

    renderContents(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-cart-inner]');
      const current = this.querySelector('[data-cart-inner]');
      if (!fresh || !current) return;
      const active = document.activeElement;
      const hadFocus = this.contains(active);
      let focusSelector = null;
      if (hadFocus && active.hasAttribute('data-key')) {
        const kinds = ['data-cart-minus', 'data-cart-plus', 'data-cart-qty', 'data-cart-remove'];
        for (const kind of kinds) {
          if (active.hasAttribute(kind)) {
            focusSelector = '[' + kind + '][data-key="' + active.getAttribute('data-key') + '"]';
            break;
          }
        }
      }
      current.innerHTML = fresh.innerHTML;
      if (!hadFocus || !this.classList.contains('is-open')) return;
      let target = null;
      if (focusSelector) target = this.querySelector(focusSelector);
      if (target) {
        target.focus();
        return;
      }
      // The control that had focus is gone (line removed, cart emptied):
      // re-arm the trap on the first focusable control rather than leaving
      // focus on <body>, where the next Tab would walk out of the drawer.
      this.focusPanel();
    }

    // The live region is re-read on every use instead of being trusted from
    // connectedCallback: it sits outside [data-cart-inner] today, but a stale
    // reference is exactly how an announcement ends up written to a detached
    // node and the region stays empty for the screen reader.
    liveRegion() {
      if (!this.statusEl || !this.contains(this.statusEl)) {
        this.statusEl = this.querySelector('[data-cart-status]');
      }
      return this.statusEl;
    }

    // Clear-then-set: assistive technology only announces a CHANGE inside a
    // live region, so writing the same wording twice in a row (two adds of the
    // same product) is silent unless the region is emptied first.
    announce(message, isError) {
      const region = this.liveRegion();
      if (!region || !message) return;
      window.clearTimeout(this.statusTimer);
      region.textContent = '';
      region.classList.toggle('fl-cart__status--error', isError === true);
      // Written from BOTH a frame callback and a timer, whichever lands first:
      // requestAnimationFrame alone is throttled to a standstill in a hidden or
      // backgrounded tab, which left the region measurably empty for a full
      // second after an add — long enough for the shopper to hear nothing.
      const write = () => {
        if (region.textContent === message) return;
        region.textContent = message;
        // An error stays on screen until the next cart action resolves it; a
        // confirmation is transient and takes itself back down.
        if (isError) return;
        window.clearTimeout(this.statusTimer);
        this.statusTimer = window.setTimeout(() => {
          if (region.textContent === message) region.textContent = '';
        }, 5000);
      };
      window.requestAnimationFrame(write);
      window.setTimeout(write, 50);
    }

    showError(message) {
      this.announce(message || this.dataset.errorText, true);
    }

    clearError() {
      const region = this.liveRegion();
      if (!region) return;
      if (!region.classList.contains('fl-cart__status--error')) return;
      window.clearTimeout(this.statusTimer);
      region.classList.remove('fl-cart__status--error');
      region.textContent = '';
    }
  }

  if (!customElements.get('fl-cart-drawer')) {
    customElements.define('fl-cart-drawer', FlCartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  class FlCartPage extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.status = this.querySelector('[data-cart-page-status]');
      this.submitTimer = null;
      if (!this.form) return;
      this.classList.add('is-enhanced');
      this.onClick = this.handleClick.bind(this);
      this.onChange = this.handleChange.bind(this);
      this.onSubmit = this.handleSubmit.bind(this);
      this.addEventListener('click', this.onClick);
      this.addEventListener('change', this.onChange);
      this.form.addEventListener('submit', this.onSubmit);
    }

    disconnectedCallback() {
      window.clearTimeout(this.submitTimer);
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('change', this.onChange);
      if (this.form) this.form.removeEventListener('submit', this.onSubmit);
    }

    handleClick(event) {
      const button = event.target.closest('[data-qty-minus], [data-qty-plus]');
      if (!button) return;
      const wrap = button.closest('[data-qty-wrap]');
      if (!wrap) return;
      const input = wrap.querySelector('[data-qty-input]');
      if (!input) return;
      let value = parseInt(input.value, 10);
      if (Number.isNaN(value)) value = 0;
      if (button.hasAttribute('data-qty-minus')) {
        value = Math.max(0, value - 1);
      } else {
        value = value + 1;
      }
      input.value = value;
      this.queueSubmit();
    }

    handleChange(event) {
      if (!event.target.closest('[data-qty-input]')) return;
      this.queueSubmit();
    }

    handleSubmit() {
      window.clearTimeout(this.submitTimer);
      this.classList.add('is-busy');
      if (this.status) this.status.textContent = this.dataset.loadingText || '';
    }

    queueSubmit() {
      window.clearTimeout(this.submitTimer);
      this.submitTimer = window.setTimeout(() => {
        if (!this.form) return;
        if (typeof this.form.requestSubmit === 'function') {
          this.form.requestSubmit();
        } else {
          this.form.submit();
        }
      }, 400);
    }
  }

  if (!customElements.get('fl-cart-page')) {
    customElements.define('fl-cart-page', FlCartPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collage"] && !Shopify.designMode) return;
  try {
    
  class FlVideoTile extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('click', (event) => {
        const target = event.target;
        const trigger = target && target.closest ? target.closest('[data-video-play]') : null;
        if (!trigger) return;
        const src = this.dataset.videoSrc;
        if (!src) return;
        event.preventDefault();
        this.play(src);
      });
    }

    play(src) {
      const holder = this.querySelector('[data-video-holder]');
      if (!holder) return;
      const frame = document.createElement('iframe');
      frame.className = 'fl-collage__frame';
      frame.src = src;
      frame.title = this.dataset.videoTitle || '';
      frame.allow = 'autoplay; encrypted-media; picture-in-picture';
      frame.setAttribute('allowfullscreen', '');
      holder.textContent = '';
      holder.appendChild(frame);
      frame.focus();
    }
  }

  if (!customElements.get('fl-video-tile')) customElements.define('fl-video-tile', FlVideoTile);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  class FlCollectionFilters extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-filter-form]');
      this.drawer = this.querySelector('[data-facets-drawer]');
      this.facets = Array.from(this.querySelectorAll('[data-facet]'));
      this.mq = window.matchMedia('(min-width: 750px)');

      this.onMqChange = this.syncLayout.bind(this);
      this.onDocClick = this.handleDocClick.bind(this);
      this.onKeydown = this.handleKeydown.bind(this);
      this.onFormChange = this.handleFormChange.bind(this);

      if (this.form) this.form.addEventListener('change', this.onFormChange);

      this.facets.forEach((facet) => {
        facet.addEventListener('toggle', () => {
          if (!facet.open) return;
          this.facets.forEach((other) => {
            if (other !== facet) other.open = false;
          });
        });
      });

      document.addEventListener('click', this.onDocClick);
      this.addEventListener('keydown', this.onKeydown);
      if (this.mq.addEventListener) this.mq.addEventListener('change', this.onMqChange);

      this.syncLayout();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
      if (this.mq && this.mq.removeEventListener) this.mq.removeEventListener('change', this.onMqChange);
    }

    syncLayout() {
      if (!this.drawer) return;
      if (this.mq.matches) {
        this.drawer.setAttribute('open', '');
        this.drawer.classList.add('fl-toolbar__drawer--inline');
      } else {
        this.drawer.classList.remove('fl-toolbar__drawer--inline');
        this.drawer.removeAttribute('open');
      }
    }

    handleFormChange(event) {
      const target = event.target;
      if (!target) return;
      if (target.classList.contains('fl-facet__checkbox') || target.hasAttribute('data-sort')) {
        this.submitForm();
      }
    }

    submitForm() {
      if (!this.form) return;
      this.clampPriceInputs();
      if (!this.form.checkValidity()) {
        // A field that constraint validation rejects would silently block
        // requestSubmit(), and the browser cannot show its bubble inside a
        // closed <details>. Open the offending facet (and the mobile
        // drawer) first so the native message is actually visible.
        const invalid = this.form.querySelector(':invalid');
        if (invalid) {
          if (this.drawer && this.drawer.contains(invalid)) this.drawer.setAttribute('open', '');
          const facet = invalid.closest('[data-facet]');
          if (facet) facet.open = true;
        }
        this.form.reportValidity();
        return;
      }
      if (this.form.requestSubmit) this.form.requestSubmit();
      else this.form.submit();
    }

    clampPriceInputs() {
      // Out-of-range or off-step price values (e.g. 99 when max is 32, or
      // 14.999) must not veto an unrelated filter/sort submit: clamp them
      // to the input bounds and round to the step instead. Shopify clamps
      // price filters server-side anyway, so this never changes results.
      const inputs = this.form.querySelectorAll('.fl-facet__price-input');
      inputs.forEach((input) => {
        if (input.value === '') return;
        let value = Number(input.value);
        if (Number.isNaN(value)) return;
        const min = Number(input.min);
        const max = Number(input.max);
        if (input.min !== '' && !Number.isNaN(min)) value = Math.max(value, min);
        if (input.max !== '' && !Number.isNaN(max)) value = Math.min(value, max);
        input.value = value.toFixed(2);
      });
    }

    handleDocClick(event) {
      if (this.contains(event.target)) return;
      this.closeFacets();
      if (this.drawer && !this.drawer.classList.contains('fl-toolbar__drawer--inline')) {
        this.drawer.removeAttribute('open');
      }
    }

    handleKeydown(event) {
      if (event.key !== 'Escape') return;
      const openFacet = this.facets.find((facet) => facet.open);
      if (openFacet) {
        openFacet.open = false;
        const summary = openFacet.querySelector('summary');
        if (summary) summary.focus();
        return;
      }
      if (this.drawer && this.drawer.open && !this.drawer.classList.contains('fl-toolbar__drawer--inline')) {
        this.drawer.removeAttribute('open');
        const toggle = this.drawer.querySelector('summary');
        if (toggle) toggle.focus();
      }
    }

    closeFacets() {
      this.facets.forEach((facet) => {
        facet.open = false;
      });
    }
  }

  if (!customElements.get('fl-collection-filters')) {
    customElements.define('fl-collection-filters', FlCollectionFilters);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
    
  class FlCountdown extends HTMLElement {
    connectedCallback() {
      this.end = new Date(this.dataset.end || '');
      this.timer = this.querySelector('[data-timer]');
      this.expired = this.querySelector('[data-expired]');
      this.values = {};
      this.querySelectorAll('[data-unit]').forEach((el) => {
        this.values[el.dataset.unit] = el;
      });
      this.labels = (this.dataset.labels || '').split('|');
      this.lastMinute = null;

      if (!this.timer || isNaN(this.end.getTime())) {
        if (this.timer) this.timer.hidden = true;
        return;
      }

      this.tick();
      this.interval = window.setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      if (this.interval) window.clearInterval(this.interval);
      this.interval = null;
    }

    tick() {
      const diff = this.end.getTime() - Date.now();
      if (diff <= 0) {
        this.finish();
        return;
      }

      const total = Math.floor(diff / 1000);
      const parts = {
        days: Math.floor(total / 86400),
        hours: Math.floor((total % 86400) / 3600),
        minutes: Math.floor((total % 3600) / 60),
        seconds: total % 60,
      };

      Object.keys(parts).forEach((key) => {
        const el = this.values[key];
        if (!el) return;
        const text = key === 'days' ? String(parts[key]) : String(parts[key]).padStart(2, '0');
        if (el.textContent !== text) el.textContent = text;
      });

      const minuteKey = parts.days + ':' + parts.hours + ':' + parts.minutes;
      if (minuteKey !== this.lastMinute) {
        this.lastMinute = minuteKey;
        this.timer.setAttribute(
          'aria-label',
          parts.days + ' ' + (this.labels[0] || '') + ', ' +
            parts.hours + ' ' + (this.labels[1] || '') + ', ' +
            parts.minutes + ' ' + (this.labels[2] || '')
        );
      }
    }

    finish() {
      this.disconnectedCallback();
      if (this.hasAttribute('data-hide-expired')) {
        const root = this.closest('.fl-countdown');
        if (root) root.hidden = true;
        return;
      }
      this.timer.hidden = true;
      if (this.expired) this.expired.hidden = false;
    }
  }

  if (!customElements.get('fl-countdown')) customElements.define('fl-countdown', FlCountdown);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-addresses"]) return;
  try {
    
  if (!customElements.get('fl-addresses')) {
    customElements.define(
      'fl-addresses',
      class FlAddresses extends HTMLElement {
        connectedCallback() {
          this.querySelectorAll('[data-country-select]').forEach((select) => {
            this._wireProvinces(select);
          });
          this.addEventListener('submit', this._onSubmit);
        }

        disconnectedCallback() {
          this.removeEventListener('submit', this._onSubmit);
        }

        _onSubmit = (event) => {
          const form = event.target.closest('[data-confirm]');
          if (!form) return;
          if (!window.confirm(form.getAttribute('data-confirm'))) event.preventDefault();
        };

        _wireProvinces(select) {
          const wrapper = this.querySelector(`[data-province-wrapper="${select.dataset.countrySelect}"]`);
          if (!wrapper) return;
          const province = wrapper.querySelector('select');

          const fill = () => {
            const option = select.options[select.selectedIndex];
            let values = [];
            try {
              values = JSON.parse(option.getAttribute('data-provinces') || '[]');
            } catch (error) {
              values = [];
            }
            province.innerHTML = '';
            if (!values.length) {
              wrapper.hidden = true;
              return;
            }
            values.forEach((pair) => {
              const opt = document.createElement('option');
              opt.value = pair[0];
              opt.textContent = pair[1];
              province.appendChild(opt);
            });
            const preset = province.getAttribute('data-default');
            if (preset) province.value = preset;
            wrapper.hidden = false;
          };

          const preset = select.getAttribute('data-default');
          if (preset) select.value = preset;
          select.addEventListener('change', fill);
          fill();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-login"]) return;
  try {
    
  if (!customElements.get('fl-login')) {
    customElements.define(
      'fl-login',
      class FlLogin extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', this._onClick);
        }

        disconnectedCallback() {
          this.removeEventListener('click', this._onClick);
        }

        // The anchors are allowed to change the hash so the :target rules stay
        // the single source of truth; JS only clears the posted-state attribute
        // and moves focus into the pane that just appeared.
        _onClick = (event) => {
          const show = event.target.closest('[data-recover-show]');
          const hide = event.target.closest('[data-recover-hide]');
          if (!show && !hide) return;
          this.removeAttribute('data-recover-open');
          const pane = this.querySelector(show ? '[data-pane="recover"]' : '[data-pane="login"]');
          window.requestAnimationFrame(() => {
            const field = pane.querySelector('input');
            if (field) field.focus();
          });
        };
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fl-featured-product')) {
    customElements.define(
      'fl-featured-product',
      class extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('[data-product-form]');
          this.variantInput = this.querySelector('[data-variant-input]');
          if (this.variantInput) this.variantInput.disabled = false;
          this.addButton = this.querySelector('[data-add-button]');
          this.addLabel = this.querySelector('[data-add-label]');
          this.addStatus = this.querySelector('[data-add-status]');
          this.priceTarget = this.querySelector('[data-price]');

          this.variants = [];
          this.money = {};
          try {
            const variantsEl = this.querySelector('[data-variants-json]');
            const moneyEl = this.querySelector('[data-money-json]');
            if (variantsEl) this.variants = JSON.parse(variantsEl.textContent);
            if (moneyEl) this.money = JSON.parse(moneyEl.textContent);
          } catch (error) {
            this.variants = [];
            this.money = {};
          }

          this.fieldsets = Array.from(this.querySelectorAll('[data-option-fieldset]'));
          this.fieldsets.forEach((fieldset) => {
            fieldset.addEventListener('change', () => this.onOptionChange());
          });
          if (this.fieldsets.length) this.refreshCombos();

          this.initGallery();
          this.initQuantity();
          this.initFormStates();
        }

        disconnectedCallback() {
          if (this._onCartChange) document.removeEventListener('fl:cart:change', this._onCartChange);
          window.clearTimeout(this._revertTimer);
        }

        /* --- Gallery --- */
        initGallery() {
          this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
          this.thumbs.forEach((button) => {
            button.addEventListener('click', () => this.showMedia(button.dataset.mediaId));
          });
        }

        showMedia(id) {
          const target = this.querySelector('[data-media-item][data-media-id="' + id + '"]');
          if (!target) return;
          this.querySelectorAll('[data-media-item]').forEach((item) => {
            item.hidden = item !== target;
          });
          if (!this.thumbs) return;
          this.thumbs.forEach((button) => {
            if (button.dataset.mediaId === String(id)) {
              button.setAttribute('aria-current', 'true');
            } else {
              button.removeAttribute('aria-current');
            }
          });
        }

        /* --- Quantity stepper --- */
        initQuantity() {
          const input = this.querySelector('[data-qty-input]');
          if (!input) return;
          const clamp = (n) => (Number.isNaN(n) ? 1 : Math.max(1, n));
          const minus = this.querySelector('[data-qty-minus]');
          const plus = this.querySelector('[data-qty-plus]');
          if (minus) {
            minus.addEventListener('click', () => {
              input.value = clamp(parseInt(input.value, 10) - 1);
            });
          }
          if (plus) {
            plus.addEventListener('click', () => {
              input.value = clamp(parseInt(input.value, 10) + 1);
            });
          }
          input.addEventListener('change', () => {
            input.value = clamp(parseInt(input.value, 10));
          });
        }

        /* --- Variants --- */
        selectedOptions() {
          return this.fieldsets.map((fieldset) => {
            const checked = fieldset.querySelector('input:checked');
            return checked ? checked.value : null;
          });
        }

        currentVariant() {
          if (!this.variants.length) return null;
          if (!this.fieldsets.length) {
            const id = this.variantInput ? this.variantInput.value : null;
            return this.variants.find((v) => String(v.id) === String(id)) || null;
          }
          const selected = this.selectedOptions();
          return this.variants.find((v) => v.options.every((value, i) => value === selected[i])) || null;
        }

        onOptionChange() {
          const variant = this.currentVariant();
          this.refreshCombos();
          this.updatePrice(variant);
          this.updateButton(variant);
          if (!variant) return;
          if (this.variantInput) this.variantInput.value = variant.id;
          if (variant.featured_media && variant.featured_media.id) this.showMedia(variant.featured_media.id);
        }

        refreshCombos() {
          const selected = this.selectedOptions();
          this.fieldsets.forEach((fieldset, i) => {
            const checked = fieldset.querySelector('input:checked');
            const legendValue = fieldset.querySelector('[data-option-value]');
            if (legendValue && checked) legendValue.textContent = checked.value;
            fieldset.querySelectorAll('input[type="radio"]').forEach((radio) => {
              const hypothetical = selected.slice();
              hypothetical[i] = radio.value;
              const matches = this.variants.filter((v) => v.options.every((value, j) => value === hypothetical[j]));
              const label = radio.nextElementSibling;
              if (!label) return;
              const status = label.querySelector('[data-value-status]');
              label.classList.remove('is-soldout', 'is-unavailable');
              if (status) status.textContent = '';
              if (!matches.length) {
                label.classList.add('is-unavailable');
                if (status) status.textContent = ', ' + this.dataset.textUnavailable;
              } else if (!matches.some((v) => v.available)) {
                label.classList.add('is-soldout');
                if (status) status.textContent = ', ' + this.dataset.textSoldout;
              }
            });
          });
        }

        updatePrice(variant) {
          if (!this.priceTarget || !variant) return;
          const money = this.money[String(variant.id)];
          if (!money) return;
          const classes =
            'fl-price' +
            (money.compare ? ' fl-price--sale' : '') +
            (money.available === false ? ' fl-price--soldout' : '');
          let html = '<span class="' + classes + '">';
          if (money.available === false) {
            html += '<span class="visually-hidden">' + this.dataset.textSoldout + '</span>';
          }
          html += '<span class="fl-price__current">' + money.price + '</span>';
          if (money.compare) {
            html +=
              '<s class="fl-price__compare"><span class="visually-hidden">' +
              this.dataset.textRegular +
              '</span>' +
              money.compare +
              '</s>';
          }
          if (money.unit) {
            const ref = money.unitRef && money.unitRef !== 1 ? money.unitRef + ' ' : '';
            html += '<span class="fl-price__unit">' + money.unit + ' / ' + ref + money.unitUnit + '</span>';
          }
          html += '</span>';
          this.priceTarget.innerHTML = html;
        }

        updateButton(variant) {
          if (!this.addButton || !this.addLabel) return;
          if (this.addStatus) this.addStatus.textContent = '';
          if (!variant) {
            if (!this.variants.length) return;
            this.addButton.setAttribute('disabled', '');
            this.addLabel.textContent = this.dataset.textUnavailable;
            return;
          }
          if (!variant.available) {
            this.addButton.setAttribute('disabled', '');
            this.addLabel.textContent = this.dataset.textSoldout;
            return;
          }
          this.addButton.removeAttribute('disabled');
          this.addLabel.textContent = this.dataset.textAdd;
        }

        /* --- Add-to-cart button states (adding / added) --- */
        initFormStates() {
          if (!this.form || !this.addButton) return;
          this._onCartChange = () => {
            if (!this._adding) return;
            this._adding = false;
            window.clearTimeout(this._revertTimer);
            if (this.addLabel) this.addLabel.textContent = this.dataset.textAdded;
            if (this.addStatus) this.addStatus.textContent = this.dataset.textAdded;
            this._revertTimer = window.setTimeout(() => this.updateButton(this.currentVariant()), 2000);
          };
          document.addEventListener('fl:cart:change', this._onCartChange);
          this.form.addEventListener('submit', () => {
            this._adding = true;
            if (this.addLabel) this.addLabel.textContent = this.dataset.textAdding;
            if (this.addStatus) this.addStatus.textContent = this.dataset.textAdding;
            window.clearTimeout(this._revertTimer);
            this._revertTimer = window.setTimeout(() => {
              this._adding = false;
              this.updateButton(this.currentVariant());
            }, 8000);
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!customElements.get('fl-localization')) {
    customElements.define(
      'fl-localization',
      class extends HTMLElement {
        connectedCallback() {
          const select = this.querySelector('select');
          const button = this.querySelector('[data-loc-submit]');
          if (!select) return;
          if (button) button.hidden = true;
          select.addEventListener('change', () => {
            const form = this.closest('form');
            if (form) form.submit();
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class FlHeader extends HTMLElement {
    connectedCallback() {
      this.drawer = this.querySelector('[data-menu-drawer]');
      this.burger = this.querySelector('[data-menu-open]');
      this.cartLink = this.querySelector('[data-cart-link]');
      this.cartLive = this.querySelector('[data-cart-live]');
      this.dropdowns = Array.from(this.querySelectorAll('[data-dropdown]'));

      if (this.burger && this.drawer) {
        this.burger.addEventListener('click', () => this.openDrawer());
        this.drawer.addEventListener('click', (event) => {
          if (event.target === this.drawer) this.drawer.close();
        });
        this.drawer.addEventListener('close', () => {
          this.burger.setAttribute('aria-expanded', 'false');
        });
        this.querySelectorAll('[data-menu-close]').forEach((btn) => {
          btn.addEventListener('click', () => this.drawer.close());
        });
      }

      this.dropdowns.forEach((dropdown) => {
        const summary = dropdown.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', String(dropdown.open));
        dropdown.addEventListener('toggle', () => {
          if (summary) summary.setAttribute('aria-expanded', String(dropdown.open));
          if (dropdown.open) this.closeDropdowns(dropdown);
        });
        dropdown.addEventListener('focusout', (event) => {
          if (!dropdown.open) return;
          if (event.relatedTarget && !dropdown.contains(event.relatedTarget)) dropdown.open = false;
        });
        dropdown.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && dropdown.open) {
            event.preventDefault();
            dropdown.open = false;
            if (summary) summary.focus();
          }
        });
      });

      this._onDocClick = (event) => {
        this.dropdowns.forEach((dropdown) => {
          if (dropdown.open && !dropdown.contains(event.target)) dropdown.open = false;
        });
      };
      document.addEventListener('click', this._onDocClick);

      this._onCartChange = (event) => this.updateCartCount(event);
      document.addEventListener('fl:cart:change', this._onCartChange);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._onDocClick);
      document.removeEventListener('fl:cart:change', this._onCartChange);
    }

    openDrawer() {
      if (typeof this.drawer.showModal === 'function') {
        this.drawer.showModal();
      } else {
        this.drawer.setAttribute('open', '');
      }
      this.burger.setAttribute('aria-expanded', 'true');
    }

    closeDropdowns(except) {
      this.dropdowns.forEach((dropdown) => {
        if (dropdown !== except) dropdown.open = false;
      });
    }

    updateCartCount(event) {
      if (!event.detail || typeof event.detail.itemCount !== 'number') return;
      const count = event.detail.itemCount;
      this.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = count;
        el.classList.toggle('is-empty', count === 0);
      });
      const template = count === 1 ? this.dataset.cartLabelOne : this.dataset.cartLabelOther;
      if (!template) return;
      const label = template.replace('%COUNT%', count);
      if (this.cartLink) this.cartLink.setAttribute('aria-label', label);
      if (this.cartLive) this.cartLive.textContent = label;
    }
  }

  if (!customElements.get('fl-header')) customElements.define('fl-header', FlHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-split"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fl-hero')) {
    customElements.define(
      'fl-hero',
      class extends HTMLElement {
        connectedCallback() {
          var el = this;
          requestAnimationFrame(function () {
            el.classList.add('is-vue');
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  if (!customElements.get('fl-product')) {
    customElements.define(
      'fl-product',
      class extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('[data-product-form]');
          this.variantInput = this.querySelector('[data-variant-input]');
          // Scripting is on, so this field is now the source of truth.
          if (this.variantInput) this.variantInput.disabled = false;
          this.addButton = this.querySelector('[data-add-button]');
          this.addLabel = this.querySelector('[data-add-label]');
          this.addStatus = this.querySelector('[data-add-status]');
          this.priceTarget = this.querySelector('[data-price]');

          this.variants = [];
          this.money = {};
          try {
            const variantsEl = this.querySelector('[data-variants-json]');
            const moneyEl = this.querySelector('[data-money-json]');
            if (variantsEl) this.variants = JSON.parse(variantsEl.textContent);
            if (moneyEl) this.money = JSON.parse(moneyEl.textContent);
          } catch (error) {
            this.variants = [];
            this.money = {};
          }

          this.fieldsets = Array.from(this.querySelectorAll('[data-option-fieldset]'));
          this.fieldsets.forEach((fieldset) => {
            fieldset.addEventListener('change', () => this.onOptionChange());
          });
          if (this.fieldsets.length) this.refreshCombos();

          this.initGallery();
          this.initQuantity();
          this.initFormStates();
        }

        disconnectedCallback() {
          if (this._onCartChange) document.removeEventListener('fl:cart:change', this._onCartChange);
          window.clearTimeout(this._revertTimer);
        }

        /* --- Gallery --- */
        initGallery() {
          this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
          this.thumbs.forEach((button) => {
            button.addEventListener('click', () => this.showMedia(button.dataset.mediaId));
          });
        }

        showMedia(id) {
          const target = this.querySelector('[data-media-item][data-media-id="' + id + '"]');
          if (!target) return;
          this.querySelectorAll('[data-media-item]').forEach((item) => {
            item.hidden = item !== target;
          });
          if (!this.thumbs) return;
          this.thumbs.forEach((button) => {
            if (button.dataset.mediaId === String(id)) {
              button.setAttribute('aria-current', 'true');
            } else {
              button.removeAttribute('aria-current');
            }
          });
        }

        /* --- Quantity stepper --- */
        initQuantity() {
          const input = this.querySelector('[data-qty-input]');
          if (!input) return;
          const clamp = (n) => (Number.isNaN(n) ? 1 : Math.max(1, n));
          const minus = this.querySelector('[data-qty-minus]');
          const plus = this.querySelector('[data-qty-plus]');
          if (minus) {
            minus.addEventListener('click', () => {
              input.value = clamp(parseInt(input.value, 10) - 1);
            });
          }
          if (plus) {
            plus.addEventListener('click', () => {
              input.value = clamp(parseInt(input.value, 10) + 1);
            });
          }
          input.addEventListener('change', () => {
            input.value = clamp(parseInt(input.value, 10));
          });
        }

        /* --- Variants --- */
        selectedOptions() {
          return this.fieldsets.map((fieldset) => {
            const checked = fieldset.querySelector('input:checked');
            return checked ? checked.value : null;
          });
        }

        currentVariant() {
          if (!this.variants.length) return null;
          if (!this.fieldsets.length) {
            const id = this.variantInput ? this.variantInput.value : null;
            return this.variants.find((v) => String(v.id) === String(id)) || null;
          }
          const selected = this.selectedOptions();
          return this.variants.find((v) => v.options.every((value, i) => value === selected[i])) || null;
        }

        onOptionChange() {
          const variant = this.currentVariant();
          this.refreshCombos();
          this.updatePrice(variant);
          this.updateButton(variant);
          if (!variant) return;
          if (this.variantInput) this.variantInput.value = variant.id;
          if (variant.featured_media && variant.featured_media.id) this.showMedia(variant.featured_media.id);
          if (window.history && window.history.replaceState) {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url.toString());
          }
        }

        refreshCombos() {
          const selected = this.selectedOptions();
          this.fieldsets.forEach((fieldset, i) => {
            const checked = fieldset.querySelector('input:checked');
            const legendValue = fieldset.querySelector('[data-option-value]');
            if (legendValue && checked) legendValue.textContent = checked.value;
            fieldset.querySelectorAll('input[type="radio"]').forEach((radio) => {
              const hypothetical = selected.slice();
              hypothetical[i] = radio.value;
              const matches = this.variants.filter((v) => v.options.every((value, j) => value === hypothetical[j]));
              const label = radio.nextElementSibling;
              if (!label) return;
              const status = label.querySelector('[data-value-status]');
              label.classList.remove('is-soldout', 'is-unavailable');
              if (status) status.textContent = '';
              if (!matches.length) {
                label.classList.add('is-unavailable');
                if (status) status.textContent = ', ' + this.dataset.textUnavailable;
              } else if (!matches.some((v) => v.available)) {
                label.classList.add('is-soldout');
                if (status) status.textContent = ', ' + this.dataset.textSoldout;
              }
            });
          });
        }

        updatePrice(variant) {
          if (!this.priceTarget || !variant) return;
          const money = this.money[String(variant.id)];
          if (!money) return;
          const classes =
            'fl-price' +
            (money.compare ? ' fl-price--sale' : '') +
            (money.available === false ? ' fl-price--soldout' : '');
          let html = '<span class="' + classes + '">';
          if (money.available === false) {
            html += '<span class="visually-hidden">' + this.dataset.textSoldout + '</span>';
          }
          html += '<span class="fl-price__current">' + money.price + '</span>';
          if (money.compare) {
            html +=
              '<s class="fl-price__compare"><span class="visually-hidden">' +
              this.dataset.textRegular +
              '</span>' +
              money.compare +
              '</s>';
          }
          // Keep the unit price in sync; it used to be wiped on the first change.
          if (money.unit) {
            const ref = money.unitRef && money.unitRef !== 1 ? money.unitRef + ' ' : '';
            html += '<span class="fl-price__unit">' + money.unit + ' / ' + ref + money.unitUnit + '</span>';
          }
          html += '</span>';
          this.priceTarget.innerHTML = html;
        }

        updateButton(variant) {
          if (!this.addButton || !this.addLabel) return;
          if (this.addStatus) this.addStatus.textContent = '';
          if (!variant) {
            if (!this.variants.length) return;
            this.addButton.setAttribute('disabled', '');
            this.addLabel.textContent = this.dataset.textUnavailable;
            return;
          }
          if (!variant.available) {
            this.addButton.setAttribute('disabled', '');
            this.addLabel.textContent = this.dataset.textSoldout;
            return;
          }
          this.addButton.removeAttribute('disabled');
          this.addLabel.textContent = this.dataset.textAdd;
        }

        /* --- Add-to-cart button states (adding / added) --- */
        initFormStates() {
          if (!this.form || !this.addButton) return;
          this._onCartChange = () => {
            if (!this._adding) return;
            this._adding = false;
            window.clearTimeout(this._revertTimer);
            if (this.addLabel) this.addLabel.textContent = this.dataset.textAdded;
            if (this.addStatus) this.addStatus.textContent = this.dataset.textAdded;
            this._revertTimer = window.setTimeout(() => this.updateButton(this.currentVariant()), 2000);
          };
          document.addEventListener('fl:cart:change', this._onCartChange);
          this.form.addEventListener('submit', () => {
            this._adding = true;
            if (this.addLabel) this.addLabel.textContent = this.dataset.textAdding;
            if (this.addStatus) this.addStatus.textContent = this.dataset.textAdding;
            window.clearTimeout(this._revertTimer);
            this._revertTimer = window.setTimeout(() => {
              this._adding = false;
              this.updateButton(this.currentVariant());
            }, 8000);
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-order-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fl-quick-order')) {
    customElements.define(
      'fl-quick-order',
      class extends HTMLElement {
        connectedCallback() {
          if (this.ready) return;
          this.ready = true;
          this.isBusy = false;
          this.statusEl = this.querySelector('[data-qol-status]');
          this.addAllBtn = this.querySelector('[data-qol-add-all]');

          // Rows ship at 1 so the no-JS button adds something sensible; once the
          // bulk control takes over, an empty basket is the right starting point.
          this.eachQty((input) => {
            input.min = '0';
            input.value = '0';
          });

          this.classList.add('is-enhanced');

          this.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter') return;
            if (!event.target.closest('[data-qol-qty]')) return;
            event.preventDefault();
            this.addAll();
          });

          if (this.addAllBtn) {
            this.addAllBtn.addEventListener('click', () => this.addAll());
          }
        }

        eachQty(callback) {
          const inputs = this.querySelectorAll('[data-qol-qty]');
          Array.prototype.forEach.call(inputs, callback);
        }

        setStatus(message) {
          if (!this.statusEl) return;
          // Clearing first makes screen readers announce a repeated message.
          this.statusEl.textContent = '';
          window.requestAnimationFrame(() => {
            this.statusEl.textContent = message;
          });
        }

        collect() {
          const items = [];
          const rows = this.querySelectorAll('[data-qol-row]');
          Array.prototype.forEach.call(rows, (row) => {
            const input = row.querySelector('[data-qol-qty]');
            if (!input) return;
            const quantity = parseInt(input.value, 10);
            if (!quantity || quantity < 1) return;
            const id = parseInt(row.getAttribute('data-variant-id'), 10);
            if (!id) return;
            items.push({ id: id, quantity: quantity });
          });
          return items;
        }

        async addAll() {
          if (this.isBusy) return;
          const items = this.collect();
          if (items.length === 0) {
            this.setStatus(this.dataset.emptyText);
            return;
          }

          this.isBusy = true;
          let label = '';
          if (this.addAllBtn) {
            label = this.addAllBtn.textContent;
            this.addAllBtn.disabled = true;
            this.addAllBtn.textContent = this.dataset.addingText;
          }

          try {
            const response = await fetch(this.dataset.addUrl + '.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: items })
            });
            if (!response.ok) {
              let message = this.dataset.errorText;
              try {
                const data = await response.json();
                if (data && data.description) message = data.description;
              } catch (error) {
                // keep the generic fallback message
              }
              this.setStatus(message);
              return;
            }
            this.eachQty((input) => {
              input.value = '0';
            });
            this.setStatus(this.dataset.addedText);
            await this.notify();
          } catch (error) {
            this.setStatus(this.dataset.errorText);
          } finally {
            if (this.addAllBtn) {
              this.addAllBtn.disabled = false;
              this.addAllBtn.textContent = label;
            }
            this.isBusy = false;
          }
        }

        async notify() {
          // The cart drawer owns the cart re-render: refresh() pulls
          // ?sections=cart-drawer, swaps [data-cart-inner] and dispatches
          // 'fl:cart:change' itself. Reuse it instead of leaving the drawer on
          // the state it was rendered with at page load.
          const drawer = document.querySelector('fl-cart-drawer');
          if (drawer && typeof drawer.refresh === 'function') {
            try {
              await drawer.refresh();
              return;
            } catch (error) {
              // fall through: the header count can still be updated on its own
            }
          }

          // No drawer on the page (settings.cart_type == 'page'), or it could
          // not refresh: the header count is the only thing left to update.
          try {
            const response = await fetch(this.dataset.cartUrl + '.js', {
              headers: { Accept: 'application/json' }
            });
            const cart = await response.json();
            if (!cart || typeof cart.item_count !== 'number') return;
            document.dispatchEvent(
              new CustomEvent('fl:cart:change', { bubbles: true, detail: { itemCount: cart.item_count } })
            );
          } catch (error) {
            // the header simply keeps the count it already had
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fl-related')) {
    customElements.define(
      'fl-related',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.loaded) return;
          const url = this.dataset.url;
          if (!url) return;
          const load = () => {
            if (this.dataset.loaded) return;
            this.dataset.loaded = 'true';
            fetch(url)
              .then((response) => {
                if (!response.ok) throw new Error(String(response.status));
                return response.text();
              })
              .then((text) => {
                const doc = new DOMParser().parseFromString(text, 'text/html');
                const fresh = doc.querySelector('fl-related');
                if (fresh && fresh.innerHTML.trim().length) {
                  this.innerHTML = fresh.innerHTML;
                }
              })
              .catch(() => {});
          };
          if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  if (entry.isIntersecting) {
                    this.observer.disconnect();
                    load();
                  }
                });
              },
              { rootMargin: '400px 0px' }
            );
            this.observer.observe(this);
          } else {
            load();
          }
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-guide"] && !Shopify.designMode) return;
  try {
    
  class FlSizeGuide extends HTMLElement {
    connectedCallback() {
      this.units = this.querySelector('[data-units]');
      if (!this.units) return;
      this.units.hidden = false;
      this.querySelectorAll('.fl-size-guide__sep').forEach((el) => {
        el.hidden = true;
      });
      this.units.addEventListener('change', () => this.apply());
      this.apply();
    }

    apply() {
      const checked = this.units.querySelector('input:checked');
      const unit = checked ? checked.value : 'a';
      this.querySelectorAll('[data-unit]').forEach((el) => {
        el.hidden = el.dataset.unit !== unit;
      });
    }
  }

  if (!customElements.get('fl-size-guide')) customElements.define('fl-size-guide', FlSizeGuide);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fl-slideshow')) {
    customElements.define(
      'fl-slideshow',
      class extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll('[data-slide]'));
          if (this.slides.length === 0) return;

          this.track = this.querySelector('[data-track]');
          this.dots = Array.from(this.querySelectorAll('[data-dot]'));
          this.toggle = this.querySelector('[data-toggle]');
          this.index = 0;
          this.timer = null;
          this.paused = false;

          this.classList.add('is-enhanced');
          this.show(0);
          if (this.slides.length < 2) return;

          this.delay = 5000;
          const seconds = parseInt(this.dataset.speed, 10);
          if (seconds > 0) this.delay = seconds * 1000;
          this.autoplay = this.dataset.autoplay === 'true';

          this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.onMotionChange = () => {
            if (this.motion.matches) {
              this.stop();
            } else {
              this.start();
            }
            this.syncToggle();
          };
          this.motion.addEventListener('change', this.onMotionChange);

          const prev = this.querySelector('[data-prev]');
          const next = this.querySelector('[data-next]');
          if (prev) prev.addEventListener('click', () => this.step(-1));
          if (next) next.addEventListener('click', () => this.step(1));

          this.dots.forEach((dot, i) => {
            dot.addEventListener('click', () => this.step(i - this.index));
          });

          if (this.toggle) {
            this.toggle.addEventListener('click', () => {
              this.paused = !this.paused;
              if (this.paused) {
                this.stop();
              } else {
                this.start();
              }
              this.syncToggle();
            });
          }

          this.onKeydown = (event) => {
            if (event.key === 'ArrowLeft') {
              event.preventDefault();
              this.step(-1);
            } else if (event.key === 'ArrowRight') {
              event.preventDefault();
              this.step(1);
            }
          };
          this.addEventListener('keydown', this.onKeydown);

          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => {
            if (!this.contains(document.activeElement)) this.start();
          });
          this.addEventListener('focusin', () => this.stop());
          this.addEventListener('focusout', (event) => {
            if (!this.contains(event.relatedTarget)) this.start();
          });

          if (window.Shopify && window.Shopify.designMode) {
            this.onBlockSelect = (event) => {
              const i = this.slides.indexOf(event.target);
              if (i > -1) {
                this.paused = true;
                this.stop();
                this.show(i);
                this.syncToggle();
              }
            };
            this.onBlockDeselect = (event) => {
              if (this.slides.indexOf(event.target) > -1) {
                this.paused = false;
                this.start();
                this.syncToggle();
              }
            };
            document.addEventListener('shopify:block:select', this.onBlockSelect);
            document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
          }

          this.start();
          this.syncToggle();
        }

        disconnectedCallback() {
          this.stopTimer();
          if (this.motion && this.onMotionChange) {
            this.motion.removeEventListener('change', this.onMotionChange);
          }
          if (this.onKeydown) this.removeEventListener('keydown', this.onKeydown);
          if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
          if (this.onBlockDeselect) document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
        }

        show(i) {
          const total = this.slides.length;
          this.index = ((i % total) + total) % total;
          this.slides.forEach((slide, j) => slide.classList.toggle('is-active', j === this.index));
          this.dots.forEach((dot, j) => {
            if (j === this.index) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });
        }

        step(delta) {
          if (this.track) this.track.setAttribute('aria-live', 'polite');
          this.show(this.index + delta);
          this.restart();
        }

        start() {
          if (!this.autoplay) return;
          if (this.paused) return;
          if (this.motion.matches) return;
          this.stopTimer();
          if (this.track) this.track.setAttribute('aria-live', 'off');
          this.timer = setInterval(() => this.show(this.index + 1), this.delay);
        }

        restart() {
          if (!this.timer) return;
          this.stopTimer();
          this.timer = setInterval(() => this.show(this.index + 1), this.delay);
        }

        stop() {
          this.stopTimer();
          if (this.track) this.track.setAttribute('aria-live', 'polite');
        }

        stopTimer() {
          if (this.timer) clearInterval(this.timer);
          this.timer = null;
        }

        syncToggle() {
          if (!this.toggle) return;
          const isPaused = this.paused || this.motion.matches;
          this.toggle.classList.toggle('is-paused', isPaused);
          const label = isPaused ? this.toggle.dataset.labelPlay : this.toggle.dataset.labelPause;
          if (label) this.toggle.setAttribute('aria-label', label);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fl-testimonials')) {
    customElements.define(
      'fl-testimonials',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.prev = this.querySelector('[data-prev]');
          this.next = this.querySelector('[data-next]');
          if (!this.track || !this.prev || !this.next) return;

          this.items = Array.from(this.track.querySelectorAll('[data-item]'));
          if (this.items.length < 2) return;

          this.classList.add('is-enhanced');
          this.prev.addEventListener('click', () => this.step(-1));
          this.next.addEventListener('click', () => this.step(1));
          this.track.addEventListener('scroll', () => this.update(), { passive: true });
          this.update();
        }

        step(direction) {
          const width = this.items[0].getBoundingClientRect().width || this.track.clientWidth;
          this.track.scrollBy({ left: width * direction });
        }

        update() {
          const max = this.track.scrollWidth - this.track.clientWidth - 1;
          this.prev.disabled = this.track.scrollLeft <= 0;
          this.next.disabled = this.track.scrollLeft >= max;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fl-video')) {
    customElements.define(
      'fl-video',
      class extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('[data-play]');
          this.stage = this.querySelector('[data-stage]');
          this.template = this.querySelector('template');
          if (!this.button || !this.stage || !this.template) return;

          this.onClick = () => this.load();
          this.button.addEventListener('click', this.onClick);
          this.classList.add('is-enhanced');
        }

        disconnectedCallback() {
          if (this.button && this.onClick) this.button.removeEventListener('click', this.onClick);
        }

        load() {
          if (this.loaded) return;
          this.loaded = true;

          this.stage.appendChild(this.template.content.cloneNode(true));
          const player = this.stage.querySelector('iframe, video');
          if (player) {
            player.setAttribute('tabindex', '0');
            player.focus();
            if (typeof player.play === 'function') {
              const started = player.play();
              if (started && typeof started.catch === 'function') started.catch(() => {});
            }
          }
          this.button.remove();
          this.classList.add('is-playing');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"] && !Shopify.designMode) return;
  try {
    
  class FlWishlistPage extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-wishlist-grid]');
      this.empty = this.querySelector('[data-wishlist-empty]');
      this.clearBtn = this.querySelector('[data-wishlist-clear]');
      this.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      this._onChange = () => this.prune();
      document.addEventListener('fl:wishlist:change', this._onChange);
      if (this.clearBtn) {
        this._onClear = () => this.clear();
        this.clearBtn.addEventListener('click', this._onClear);
      }
      this.load();
    }

    disconnectedCallback() {
      document.removeEventListener('fl:wishlist:change', this._onChange);
      if (this.clearBtn) this.clearBtn.removeEventListener('click', this._onClear);
    }

    read() {
      if (window.flWishlist) return window.flWishlist.read();
      try {
        const list = JSON.parse(localStorage.getItem('fl:wishlist') || '[]');
        return Array.isArray(list) ? list : [];
      } catch (e) {
        return [];
      }
    }

    clear() {
      if (window.flWishlist) {
        window.flWishlist.write([]);
      } else {
        try {
          localStorage.removeItem('fl:wishlist');
        } catch (e) {
          /* storage unavailable */
        }
      }
      this.grid.innerHTML = '';
      this.refreshState();
    }

    refreshState() {
      const count = this.grid.children.length;
      this.empty.hidden = count > 0;
      if (this.clearBtn) this.clearBtn.hidden = count === 0;
    }

    async load() {
      const handles = this.read();
      this.grid.setAttribute('aria-busy', 'true');
      const results = await Promise.all(handles.map((handle) => this.fetchCard(handle)));
      results.forEach((card, i) => {
        if (!card) return;
        const item = document.createElement('div');
        item.className = 'fl-wishlist__item';
        item.setAttribute('data-handle', handles[i]);
        item.appendChild(card);
        this.grid.appendChild(item);
      });
      this.grid.removeAttribute('aria-busy');
      this.refreshState();
      // Buttons injected after wishlist.js ran: sync their pressed state.
      if (window.flWishlist) window.flWishlist.sync();
    }

    async fetchCard(handle) {
      try {
        const url = this.root + 'products/' + encodeURIComponent(handle) + '?section_id=wishlist-item';
        const res = await fetch(url);
        if (!res.ok) return null;
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.querySelector('.fl-card');
      } catch (e) {
        return null;
      }
    }

    // A heart unticked on this page (or in the header count) removes its card.
    prune() {
      const handles = this.read();
      this.grid.querySelectorAll('[data-handle]').forEach((item) => {
        if (!handles.includes(item.getAttribute('data-handle'))) item.remove();
      });
      this.refreshState();
    }
  }

  if (!customElements.get('fl-wishlist')) customElements.define('fl-wishlist', FlWishlistPage);

  } catch(e) { console.error(e); }
})();
})();
